import styled from 'styled-components';
import { Input } from '../../atoms';

const FormFieldContainer = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #dc3545;
`;

const FormField = ({ label, error, ...inputProps }) => {
  return (
    <FormFieldContainer>
      {label && <Label>{label}</Label>}
      <Input {...inputProps} />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormFieldContainer>
  );
};

export default FormField;
